import { reactive } from "vue";

// Shared, namespaced selection state used by bulk-delete features.
// Each `key` is an isolated group (e.g. a video group or a playbook) holding
// its own selection mode + selected ids.
const state = reactive({ groups: {} });

function ensure(key) {
    if (!state.groups[key]) {
        state.groups[key] = { mode: false, ids: [] };
    }
    return state.groups[key];
}

export default {
    state,
    isMode(key) {
        return state.groups[key]?.mode ?? false;
    },
    setMode(key, val) {
        const group = ensure(key);
        group.mode = val;
        if (!val) {
            group.ids = [];
        }
    },
    toggleMode(key) {
        this.setMode(key, !this.isMode(key));
    },
    isSelected(key, id) {
        return state.groups[key]?.ids.includes(id) ?? false;
    },
    toggle(key, id) {
        const group = ensure(key);
        const index = group.ids.indexOf(id);
        if (index === -1) {
            group.ids.push(id);
        } else {
            group.ids.splice(index, 1);
        }
    },
    selected(key) {
        return state.groups[key]?.ids.slice() ?? [];
    },
    count(key) {
        return state.groups[key]?.ids.length ?? 0;
    },
    clear(key) {
        const group = state.groups[key];
        if (group) {
            group.ids = [];
        }
    },
};
